import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { useAuthStore } from '@/shared/stores/authStore';
import { initSocketLifecycle } from '@/shared/lib/socketLifecycle';
import '@/styles/globals.css';

initSocketLifecycle();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Elemento #root não encontrado no index.html');
}

useAuthStore
  .getState()
  .hydrate()
  .catch((err) => {
    console.error('Falha ao hidratar sessão:', err);
  });

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
